import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BackgroundColors, SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $slickTheme': {
      '& .slick-dots li button': {
        '&:before': {
          color: TextColors.dark,
          backgroundColor: TextColors.dark,
          opacity: TextOpacities.light3,
        },
        '&.slick-active button:before': {
          color: SecondaryColors.dark,
          backgroundColor: SecondaryColors.dark,
          opacity: TextOpacities.light1,
        },
      },
    },
    '& $dotsArrow': {
      opacity: 0.3,
      // : 0.65,
      color: TextColors.dark,
    },
    '& $dotsContainer': {
      color: TextColors.dark,
      '& li button:before': {
        backgroundColor: BackgroundColors.light,
      },
    },
  },
};
const darkTheme = {
  root: {
    '& $slickTheme': {
      '& .slick-dots li button': {
        '&:before': {
          color: TextColors.light,
          backgroundColor: TextColors.light,
          opacity: TextOpacities.dark3,
        },
        '&.slick-active button:before': {
          color: SecondaryColors.main,
          backgroundColor: SecondaryColors.main,
          opacity: TextOpacities.dark1,
        },
      },
    },
    '& $dotsArrow': {
      opacity: 0.3,
      // : 0.65,
      color: TextColors.light,
    },
    '& $dotsContainer': {
      color: TextColors.light,
      '& li button:before': {
        backgroundColor: BackgroundColors.light,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) =>
    createStyles({
      root: {
        '&.light-theme': lightTheme.root,
        '&.dark-theme': darkTheme.root,
        position: 'relative',
        '&$withCta': {
          justifyContent: 'space-between',
        },
      },
      withCta: {},
      slick: {
        '&.slick-initialized': {
          '& .slick-slide': {
            display: 'block',
          },
        },

        '&.slick-loading': {
          '& .slick-slide': {
            visibility: 'hidden',
          },

          '& .slick-track': {
            visibility: 'hidden',
          },
        },

        '&.slick-vertical': {
          '& .slick-slide': {
            display: 'block',
            height: 'auto',
            border: '1px solid transparent',
          },
        },

        '&[dir="rtl"]': {
          '& .slick-slide': {
            float: 'right',
          },
        },

        '& .slick-slider': {
          position: 'relative',
          display: 'block',
          boxSizing: 'border-box',
          userSelect: 'none',
          touchAction: 'pan-y',
          '-webkit-tap-highlight-color': 'transparent',
        },

        '& .slick-list': {
          position: 'relative',
          overflow: 'hidden',
          display: 'block',
          margin: 0,
          padding: 0,

          '&:focus': {
            outline: 'none',
          },

          '&.dragging': {
            cursor: 'hand',
          },
        },

        '& .slick-slider .slick-track, & .slick-slider .slick-list': {
          transform: 'translate3d(0, 0, 0)',
        },

        '& .slick-track': {
          position: 'relative',
          left: 0,
          top: 0,
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',

          '&:before, &:after': {
            content: '',
            display: 'table',
          },

          '&:after': {
            clear: 'both',
          },
        },

        '& .slick-slide': {
          float: 'left',
          height: '100%',
          minHeight: '1px',
          display: 'none',

          '& img': {
            display: 'block',
          },
          '&.slick-loading img': {
            display: 'none',
          },

          '&.dragging img': {
            pointerEvents: 'none',
          },
        },

        '& .slick-arrow.slick-hidden': {
          display: 'none',
        },
      },
      slickTheme: {
        '&[dir="rtl"]': {
          '& .slick-prev': {
            left: 'auto',
            right: '-25px',

            '&:before': {
              content: '\u2192',
            },
          },
          '& .slick-next': {
            left: '-25px',
            right: 'auto',

            '&:before': {
              content: '\u2190',
            },
          },
        },

        '& .slick-prev, .slick-next': {
          position: 'absolute',
          display: 'block',
          height: '20px',
          width: '20px',
          lineHeight: '0px',
          fontSize: '0px',
          cursor: 'pointer',
          background: 'transparent',
          color: 'transparent',
          top: '50%',
          transform: 'translate(0, -50%)',
          padding: 0,
          border: 'none',
          outline: 'none',

          '&:hover, &:focus ': {
            outline: 'none',
            background: 'transparent',
            color: 'transparent',
            '&:before': {
              opacity: 1,
            },
          },

          '&.slick-disabled:before': {
            opacity: 0.75,
          },

          '&:before': {
            fontSize: '20px',
            lineHeight: 1,
            color: 'white',
            opacity: 0.75,
          },
        },

        '& .slick-prev': {
          left: '-25px',

          '&:before': {
            content: '\u2190',
          },
        },

        '& .slick-next': {
          right: '-25px',

          '&:before': {
            content: '\u2192',
          },
        },

        '& .slick-dotted.slick-slider': {
          marginBottom: '30px',
        },

        '& .slick-dots': {
          listStyle: 'none',
          textAlign: 'center',
          padding: 0,
          width: '100%',
          display: 'flex !important',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          margin: '0 auto',
          position: 'relative',
          bottom: 0,
          paddingTop: muiTheme.spacing(2.5),

          [muiTheme.breakpoints.down('sm')]: {
            justifyContent: 'center',
          },

          '& ul': {
            padding: 0,
          },

          '& li': {
            display: 'block',
            padding: 0,
            cursor: 'pointer',

            '& button': {
              position: 'relative',
              border: 0,
              background: 'transparent',
              display: 'block',
              height: '19px',
              width: '19px',
              outline: 'none',
              lineHeight: '0px',
              fontSize: '0px',
              color: 'transparent',
              cursor: 'pointer',
              '&:hover, &:focus': {
                outline: 'none',
                '&:before': {
                  opacity: 1,
                },
              },
              '&:before': {
                position: 'absolute',
                top: '50%',
                left: '50%',
                content: '""',
                width: '7px',
                height: '7px',
                lineHeight: '7px',
                textAlign: 'center',
                borderRadius: '50%',
                marginTop: '-3.5px',
                marginLeft: '-3.5px',
              },
            },
          },
        },
      },

      dotsArrow: {},

      dotsArrowsContainer: {
        '&': {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          [muiTheme.breakpoints.up('md')]: {
            paddingLeft: '40px',
          },
        },
      },
      dotsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },

      linkContainer: {
        display: 'none',
        [muiTheme.breakpoints.up('md')]: {
          display: 'inline-flex',
        },
      },
    }),
  { name: 'GenCarousel' },
);

export default useStyles;
